"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Wrapper = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div ``;
exports.Wrapper = styled_components_1.default.div `
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  background-color: #f7f7f7;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    display: none;
  }
`;
